import { inferRouterInputs } from "@trpc/server";

import { AppRouterType } from "@/common/helpers/trpc";

export type CancellationReason = NonNullable<
  inferRouterInputs<AppRouterType>["cancelDonorCommandSubscription"]["cancellationReason"]
>;

export const DONATION_CANCELLATION_REASONS = [
  "MyFinancialSituationChanged",
  "SupportDifferentCause",
  "PreferOneTimeDonations",
  "PaymentOrTechnicalIssue",
  "Other",
] as const satisfies readonly CancellationReason[];

export const MEMBERSHIP_CANCELLATION_REASONS = [
  "NotUsingBenefitsEnough",
  "CostNoLongerFitsBudget",
  "InterestsOrCircumstancesChanged",
  "PaymentOrAutoRenewIssue",
  "Other",
] as const satisfies readonly CancellationReason[];

export const CANCELLATION_REASON_TO_TRACKING: Record<CancellationReason, string> = {
  MyFinancialSituationChanged: "financial_situation_changed",
  SupportDifferentCause: "want_to_support_different_cause",
  PreferOneTimeDonations: "prefer_one_time_donations",
  PaymentOrTechnicalIssue: "payment_or_technical_issue",
  NotUsingBenefitsEnough: "not_using_benefits_enough",
  CostNoLongerFitsBudget: "cost_no_longer_fits_budget",
  InterestsOrCircumstancesChanged: "interests_or_circumstances_changed",
  PaymentOrAutoRenewIssue: "payment_or_auto_renew_issue",
  Other: "other",
};
